<template>
    <v-btn depressed height="32" :class="['back-btn', { 'fixed': fixed }]" @click="onBackClick">
        <v-icon size="15" class="mr-1">mdi-arrow-left</v-icon>
        {{ $t('common.back') }}
    </v-btn>
</template>

<script>
export default {
    name: "BackButton",
    props: {
        route: {
            type: Object,
            default: null,
        },
        fixed: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        onBackClick() {
            const vm = this
            if (!vm.route) return vm.$router.back()
            vm.pushRoute(vm.route)
        }
    }
}
</script>

<style scoped>
.back-btn {
    border-radius: 7px !important;
    border: 1px solid var(--v-outline2-base) !important;
    background: var(--v-surface2-base) !important;
    color: var(--v-txtSecondary-base) !important;
    font-size: 13px;
    font-weight: 500;
    text-transform: none !important;
    letter-spacing: normal !important;
    padding: 0 12px !important;
}

.back-btn:hover {
    color: var(--v-txtPrimary-base) !important;
}

.fixed {
    position: fixed;
    z-index: 6;
}
</style>
